import { twMerge } from 'tailwind-merge';

const bottomArrowPlacement =
  'after:left-1/2 after:translate-y-1/2 after:-translate-x-1/2 after:bottom-full after:rounded-tl';

const topArrowPlacement =
  'after:left-1/2 after:-translate-y-1/2 after:-translate-x-1/2 after:top-full after:rounded-br';

const placementReset =
  'top-auto left-auto right-auto bottom-auto translate-x-0 translate-y-0 m-0';

const afterPlacementReset = twMerge(
  'after:block after:left-auto after:right-auto after:top-auto after:bottom-auto',
  ' after:translate-x-0 after:translate-y-0 after:rounded-none',
);

export const tooltipPlacementClasses = {
  topLeft: twMerge(
    placementReset,
    topArrowPlacement,
    'left-0 right-auto bottom-full top-auto mb-4 rounded-sm rounded-bl-none translate-x-0 after:hidden ',
  ),
  topCenter: twMerge(
    placementReset,
    afterPlacementReset,
    topArrowPlacement,
    'left-1/2 bottom-full right-auto top-auto -translate-x-1/2 mb-4 rounded-sm rounded-b',
  ),
  topRight: twMerge(
    placementReset,
    topArrowPlacement,
    'right-0 bottom-full top-auto left-auto mb-4 rounded-sm rounded-br-none translate-x-0 after:hidden',
  ),
  rightTop: twMerge(
    placementReset,
    topArrowPlacement,
    'left-full bottom-0 ml-4 rounded-bl-none',
    'after:hidden',
  ),
  rightCenter: twMerge(
    placementReset,
    afterPlacementReset,
    'left-full top-1/2 bottom-auto ml-4 ',
    'translate-x-0 -translate-y-1/2 rounded-sm after:block',
    'after:left-0 after:top-1/2 after:bottom-auto',
    'after:-translate-x-1/2 after:-translate-y-1/2',
    'after:rounded-bl',
  ),
  rightBottom: twMerge(
    bottomArrowPlacement,
    placementReset,
    'rounded-sm bottom-auto',
    'left-full top-0 ml-4 rounded-tl-none ',
    'after:hidden',
  ),
  bottomLeft: twMerge(
    bottomArrowPlacement,
    placementReset,
    'rounded-sm bottom-auto',
    'left-full top-full mt-4 rounded-tl-none',
    'after:hidden',
  ),
  bottomCenter: twMerge(
    afterPlacementReset,
    bottomArrowPlacement,
    placementReset,
    'rounded-sm bottom-auto',
    'left-1/2 -translate-x-1/2 top-full mt-4',
  ),
  bottomRight: twMerge(
    bottomArrowPlacement,
    placementReset,
    'rounded-sm bottom-auto',
    'translate-x-0 translate-y-0 left-auto',
    'right-0 top-full mt-4 rounded-tr-none',
    'after:hidden',
  ),
  leftTop: twMerge(
    topArrowPlacement,
    placementReset,
    'rounded-sm bottom-full',
    'top-auto right-full mr-4 rounded-br-none',
    'after:hidden',
  ),
  leftCenter: twMerge(
    placementReset,
    afterPlacementReset,
    'top-1/2 right-full bottom-auto mr-4 rounded-sm ',
    'translate-x-0 -translate-y-1/2 after:rounded-tl-none!',
    'after:left-full after:-translate-x-1/2 after:translate-y-1/2 after:bottom-1/2 after:rounded-tr',
  ),
  leftBottom: twMerge(
    bottomArrowPlacement,
    placementReset,
    'translate-x-0 translate-y-0 left-auto top-0 bottom-auto',
    'right-full mr-4 rounded-sm rounded-tr-none',
    'after:hidden',
  ),
};
